import {useEffect, useState} from 'react'
import {CalculateDistract} from '../../../../coreGlobal/models/sale'
import {ISelect} from '../../../../coreGlobal/models/default'
import {formatMask, removeMask} from '../../../../utils/formatMonetaryToBr'
import {usePaymentConfig} from '../../../../components/PaymentConfig/core/PaymentConfigProvider'
import Swal from 'sweetalert2'
import ReasonSelect from './ReasonSelect'
import CancelItemsTable from './CancelItemsTable'
import CancelSummary from './CancelSummary'
import {PaymentModal} from './PaymentModal'
import {generateDistract} from '../FranchiseTransfer/core/_request'
interface ReasonCancelInterface {
  saleId: number
  items: CalculateDistract
  option: ISelect[]
  closeModal?: () => void
  cancellationType: ISelect
}

const ReasonCancel = ({
  saleId,
  items,
  option,
  closeModal,
  cancellationType,
}: ReasonCancelInterface) => {
  const {payment} = usePaymentConfig()

  const [reasonCancellation, setReasonCancellattion] = useState<ISelect | null>()
  const [observation, setObservation] = useState('')
  const [openObservation, setOpenObservation] = useState(false)

  const [itemsState, setItemsState] = useState(items)
  const [selectedItems, setSelectedItems] = useState<number[]>([])
  const [totalAdjustedValue, setTotalAdjustedValue] = useState(0)
  const [residualValue, setResidualValue] = useState(0)

  const [discount, setDiscount] = useState(20)
  const [amountFine, setAmountFine] = useState(150)

  const [totalPaidValue, setTotalPaidValue] = useState(formatMask(items?.totalPaidValue))

  const [hasFine, setHasFine] = useState(false)
  const [refundOption, setRefundOption] = useState(0)
  const [confirmCieloRefund, setConfirmCieloRefund] = useState(false)

  const [modalOpen, setModalOpen] = useState(false)
  const [authorizePaymentCancel, setAuthorizePaymentCancel] = useState(false)

  useEffect(() => {
    if (!modalOpen) {
      return
    }

    let totalPayment = payment?.reduce((previousValue, currentValue) => {
      return Number(previousValue) + Number(removeMask(String(currentValue.value)))
    }, 0)

    setAuthorizePaymentCancel(Number(totalPayment).toFixed(2) === Number(residualValue).toFixed(2))
  }, [payment])

  useEffect(() => {
    setConfirmCieloRefund(false)
  }, [refundOption])

  useEffect(() => {
    if (cancellationType) {
      setReasonCancellattion(null)
      setOpenObservation(false)
    }
  }, [cancellationType])

  const handleSubmit = async (type: number) => {
    Swal.fire({
      title: type == 1 ? 'Deseja cobrar o cancelamento?' : 'Deseja gerar o distrato?',
      text: 'Essa ação não poderá ser desfeita! Deseja prosseguir?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar',
      customClass: {
        confirmButton: 'btn btn-danger',
        cancelButton: 'btn btn-secondary',
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          Swal.fire({
            position: 'center',
            icon: 'info',
            title: 'Salvando...',
            showConfirmButton: false,
            allowOutsideClick: false,
          })

          let selectedBillings
          if (type == 1) {
            selectedBillings = payment.map((item) => {
              const {value, paymentRef, numberOfInstallments, ...rest} = item
              return {
                ...rest,
                amount: removeMask(value),
                installments: numberOfInstallments > 0 ? numberOfInstallments : 1,
              }
            })
          }

          const data = {
            id: saleId,
            ...(selectedBillings && {billings: selectedBillings}),
            items: selectedItems,
            percentage: discount,
            ...(hasFine && {fine: amountFine}),
            ...(refundOption && {refundOption: refundOption}),
            ...(refundOption === 2 && {confirmCieloRefund: confirmCieloRefund}),
            reason: Number(reasonCancellation?.value),
            ...(openObservation && {reason_observation: observation}),
            ...(items.hasOldRecurrence && {totalPaid: removeMask(totalPaidValue)}),
          }

          const response = await generateDistract(data)
          const recurrenceChargeError = response?.recurrenceChargeError

          Swal.fire({
            position: 'center',
            icon: recurrenceChargeError ? 'warning' : 'success',
            title: recurrenceChargeError
              ? 'Distrato gerado, mas a cobrança no cartão recorrente falhou'
              : 'Sucesso!!!',
            ...(recurrenceChargeError && {text: recurrenceChargeError}),
            showConfirmButton: true,
            allowOutsideClick: false,
            customClass: {
              confirmButton: 'btn btn-danger',
              cancelButton: 'btn btn-secondary',
            },
          }).then((result) => {
            if (result.isConfirmed) {
              window.location.reload()
            }
          })
        } catch (error: any) {
          if (error.response.status === 422) {
            let errorText = ''
            for (let key in error.response.data.errors) {
              errorText += '<li>' + error.response.data.errors[key][0] + '</li>'
            }
            await Swal.fire({
              icon: 'error',
              title: 'Ops! Revise seu formulário e tente novamente!',
              html: errorText,
              customClass: {
                confirmButton: 'btn btn-danger',
                cancelButton: 'btn btn-secondary',
              },
            })
          } else {
            await Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: error.response.data.message,
              customClass: {
                confirmButton: 'btn btn-danger',
                cancelButton: 'btn btn-secondary',
              },
            })
          }
        }
      }
    })
  }

  return (
    <>
      <ReasonSelect
        options={option}
        reason={reasonCancellation}
        setReason={setReasonCancellattion}
        observation={observation}
        setObservation={setObservation}
        openObservation={openObservation}
        setOpenObservation={setOpenObservation}
      />
      {reasonCancellation?.value && (!openObservation || observation.length > 9) && (
        <>
          <CancelItemsTable
            itemsState={itemsState}
            selectedItems={selectedItems}
            setSelectedItems={setSelectedItems}
            totalPaidValue={totalPaidValue}
            discount={discount}
            hasFine={hasFine}
            amountFine={amountFine}
            setTotalAdjustedValue={setTotalAdjustedValue}
            setResidualValue={setResidualValue}
            setItemsState={setItemsState}
          />
          {selectedItems.length > 0 && (
            <CancelSummary
              items={items}
              residualValue={residualValue}
              totalAdjustedValue={totalAdjustedValue}
              discount={discount}
              amountFine={amountFine}
              hasFine={hasFine}
              setDiscount={setDiscount}
              totalPaidValue={totalPaidValue}
              setTotalPaidValue={setTotalPaidValue}
              setAmountFine={setAmountFine}
              setHasFine={setHasFine}
              refundOption={refundOption}
              setRefundOption={setRefundOption}
              setModalOpen={setModalOpen}
              selectedItems={selectedItems}
              handleSubmit={() => handleSubmit(2)}
              confirmCieloRefund={confirmCieloRefund}
              setConfirmCieloRefund={setConfirmCieloRefund}
            />
          )}
        </>
      )}
      {modalOpen && (
        <PaymentModal
          totalPayable={residualValue}
          onClose={() => setModalOpen(false)}
          onConfirm={() => handleSubmit(1)}
          disabled={!authorizePaymentCancel}
          includeOldRecurrence={items.hasOldRecurrence}
          hideRecurrence={!items.recurrence}
          recurrenceMaxInstallments={
            items.recurrence ? Math.max(1, items.recurrence.unpaidInstallments) : undefined
          }
        />
      )}
    </>
  )
}

export default ReasonCancel
